namespace advisorop.components.servicer {

    interface ILinksController {
        $router;
    }

    class LinksController implements ILinksController {

        $router;
        //bindings 
        investor: domains.IInvestor;

        dgLinks: DevExpress.ui.dxDataGridOptions;

        links: Array<domains.ILink> = [];
        link: domains.ILink = {};

        allEntities: Array<domains.IInvestor> = [];
        entityList1: Array<domains.IInvestor> = [];
        entityList2: Array<domains.IInvestor> = [];

        categories: Array<string> = [];
        selectedCategoryName: string = "";

        allLinkTypes: Array<domains.ILinkType> = [];
        linkTypes: Array<domains.ILinkType> = [];
        linkType: domains.ILinkType = {};

        systemLoginType: any = domains.SystemLoginType;
        user: domains.identity.IUser;


        static $inject = ["identityService", "servicerService", "advisorService","generalService", "$timeout"];
        constructor(
            private identityService: services.IdentityService,
            private servicerService: services.ServicerService,
            private advisorService: services.AdvisorService,
            private generalService: services.GeneralService,
            private $timeout: ng.ITimeoutService
        ) {
            this.investor = {};

            this.dgLinks = {
                export: {
                    enabled: true,
                    fileName: "Links"
                },
                bindingOptions: {
                    dataSource: "vm.links"
                },
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                noDataText: "There are no links",
                allowColumnResizing: false,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "categoryName", caption: "Category" },
                    { dataField: "firstEntityName", caption: "Person/Entity" },
                    { dataField: "linkTypeDescription", caption: "Link Type" },
                    { dataField: "secondEntityName", caption: "Person/Entity" },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", width: "110" }
                ]
            };
        }

        FirstEntityChanged(): void {
            angular.copy(this.entityList1, this.entityList2);

            var investorIndex = this.entityList2.map(function (x) { return x.id; }).indexOf(this.link.firstEntityId);
            if (investorIndex >= 0)
                this.entityList2.splice(investorIndex, 1);
        }

        CategoryChanged(): void {
            var _this = this;
            //Filter Link Types based on selected category
            var filteredArray = this.allLinkTypes.filter(function (linkType) {
                return linkType.categoryName == _this.selectedCategoryName;
            });

            angular.copy(filteredArray, this.linkTypes);
        }

        LinkTypeChanged(): void {
            var _this = this;
            //Filter Investors based on link type
            var filteredArray = this.allEntities.filter(function (investor) {
                return !_this.linkType || (investor.investorType == domains.InvestorType.INDIVIDUAL && _this.linkType.forIndividuals == true)
                    || (investor.investorType == domains.InvestorType.COMPANY && _this.linkType.forEntities == true);
            });

            angular.copy(filteredArray, this.entityList1);
            angular.copy(filteredArray, this.entityList2);
        }

        deleteLink(link: domains.ILink): void {
            this.link.linkTypeId = this.linkType.id;
            if (this.user.systemLoginType === domains.SystemLoginType.SERVICER) {
                this.servicerService.deleteLink(link.id)
                    .success((data) => {
                        this.loadLinks();
                        toastr.success("Link has been deleted.");
                    })
                    .error((data, status) => {
                        toastr.error(`Couldn't delete link. ERROR ${status}:${data}`);
                    });
            } else if (this.user.systemLoginType === domains.SystemLoginType.ADVISOR) {
                this.advisorService.deleteLink(link.id)
                    .success((data) => {
                        this.loadLinks();
                        toastr.success("Link has been deleted.");
                    })
                    .error((data, status) => {
                        toastr.error(`Couldn't delete link. ERROR ${status}:${data}`);
                    });
            }
        };

        swapLinkEntities(): void {
            var temp = this.link.firstEntityId;
            this.link.firstEntityId = this.link.secondEntityId;
            this.link.secondEntityId = temp;

            this.FirstEntityChanged();
        }

        addLink(): void {
            this.link.linkTypeId = this.linkType.id;
            if (this.user.systemLoginType === domains.SystemLoginType.SERVICER) {
                this.servicerService.addLink(this.link)
                    .success((data) => {
                        //TODO Clear fields?
                        this.loadLinks();
                        toastr.success("Link has been added.");
                    })
                    .error((data, status) => {
                        toastr.error(`Link could not be added! ${status}:${data}`);
                    });
            } else if (this.user.systemLoginType === domains.SystemLoginType.ADVISOR) {
                this.advisorService.addLink(this.link)
                    .success((data) => {
                        this.loadLinks();
                        toastr.success("Link has been added.");
                    })
                    .error((data, status) => {
                        toastr.error(`Link could not be added! ${status}:${data}`);
                    });
            }
        }

        logout(): void {
            this.identityService.logout();
        }

        $onInit(): void {
            this.getUser();
        }

        loadEntities(type: domains.SystemLoginType = domains.SystemLoginType.SERVICER): void {
            if (type === domains.SystemLoginType.SERVICER) {
                this.servicerService.getInvestors().success((data) => {
                    angular.copy(data, this.allEntities);
                    angular.copy(data, this.entityList1);
                    angular.copy(data, this.entityList2);
                }).error((data, status) => {
                    toastr.error("Couldn't fetch Investors for Servicer. ERROR " + status + ":" + data);
                });   
            } else if (type === domains.SystemLoginType.ADVISOR) {
                this.advisorService.getInvestors().success((data) => {
                    angular.copy(data, this.allEntities);
                    angular.copy(data.filter(x => x.id === this.investor.id), this.entityList1);
                    this.link.firstEntityId = this.entityList1[0].id;
                    angular.copy(data, this.entityList2);

                }).error((data, status) => {
                    toastr.error("Couldn't fetch Investors for Advisor. ERROR " + status + ":" + data);
                }); 
            }
        }

        loadLinkTypeCategories(): void {
            this.generalService.getLinkTypeCategories()
                .then((response) => {
                    this.categories = response.data;
                    console.log('categories', this.categories);
                })
                .catch(err => {
                    toastr.error("Couldn't fetch Link Type Categories. " + err.data);
                });
        };

        loadLinkTypes(): void {
            this.generalService.getLinkTypes()
                .then((response) => {
                    angular.copy(response.data, this.allLinkTypes);
                    angular.copy(response.data, this.linkTypes);
                    //console.log('linkTypes', this.linkTypes);
                })
                .catch(err => {
                    toastr.error("Couldn't fetch Link Types. " + err.data);
                });
        };

        loadLinks(): void {
            this.generalService.getLinks()
                .then((response) => {
                    angular.copy(response.data, this.links);
                    //console.log("$ Links", this.links);
                })
                .catch(err => {
                    toastr.error("Couldn't fetch Links. " + err.data);
                });
        }

        getUser() {
            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.loadEntities(this.user.systemLoginType);
                this.loadLinkTypeCategories();
                this.loadLinkTypes();
                this.loadLinks();

            });
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "investor") {
                    if (this.investor && this.investor.id > 0) {
                        //console.log("$ investor", this.investor);
                    };
                }
            }
        }

        $routerOnActivate(next, previous) {
        }
    }



    class Links implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<",
                investor: "<",
            };
            this.controller = ["identityService", "servicerService", "advisorService", "generalService","$timeout", LinksController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/links.html';
        }
    }
    angular.module(Constants.APP).component("links", new Links());


}